import {
  FormControl,
  FormHelperText,
  FormLabel,
  // MenuItem,
  // Select,
  TextField,
} from "@mui/material";
import { InputWrapper, LabelStyle } from "../../Common/styles/form";
import TipTapFormik from "../../Tiptap/TipTapFormik";
import { SurveyEmailContentVariableChips } from "../surveyEmailContentVariables";
import SurveyInviteTemplateBanner from "../SurveyInviteTemplateBanner";

// Auto-send on participant creation — hidden until BE assign is re-enabled.
// const invitationOptions = [
//   {
//     label: "No",
//     value: "no",
//   },
//   {
//     label: "Immediately after creation",
//     value: "immediate",
//   },
//   {
//     label: "After x days",
//     value: "after_x_days",
//   },
// ];

const Invitation = ({
  // values,
  touched,
  errors,
  getFieldProps,
  setFieldValue,
  studyId,
}: any) => {
  return (
    <>
      {studyId && <SurveyInviteTemplateBanner studyId={studyId} />}
      <SurveyEmailContentVariableChips />
      <FormControl sx={InputWrapper}>
        <FormLabel sx={LabelStyle} htmlFor="email-subject">
          Email Subject <span style={{ color: "red" }}>*</span>
        </FormLabel>
        <TextField
          placeholder="Email Subject"
          id="email-subject"
          {...getFieldProps("invitationSubject")}
          error={
            touched?.invitationSubject && errors?.invitationSubject
              ? true
              : false
          }
          helperText={
            touched?.invitationSubject && errors?.invitationSubject
              ? (errors?.invitationSubject as string)
              : " "
          }
        />
      </FormControl>

      <FormControl sx={InputWrapper}>
        <FormLabel sx={LabelStyle} htmlFor="message-body">
          Message Body <span style={{ color: "red" }}>*</span>
        </FormLabel>
        <TipTapFormik name="invitationBody" setFieldValue={setFieldValue} />
        {touched?.invitationBody && errors?.invitationBody && (
          <FormHelperText error>
            {errors?.invitationBody as string}
          </FormHelperText>
        )}
        {/* <TextField
          multiline
          placeholder="Message"
          minRows={4}
          id="message-body"
          {...getFieldProps("invitationBody")}
          error={
            touched?.invitationBody && errors?.invitationBody ? true : false
          }
          helperText={
            touched?.invitationBody && errors?.invitationBody
              ? (errors?.invitationBody as string)
              : " "
          }
        /> */}
      </FormControl>

      <FormControl sx={{ ...InputWrapper, mt: 2 }}>
        <FormLabel sx={LabelStyle} htmlFor="invitation-expiry-days">
          Invitation expiry (days) <span style={{ color: "red" }}>*</span>
        </FormLabel>
        <TextField
          type="number"
          placeholder="Days"
          id="invitation-expiry-days"
          inputProps={{ min: 1, max: 365 }}
          {...getFieldProps("invitationExpiryDays")}
          error={
            touched?.invitationExpiryDays && errors?.invitationExpiryDays
              ? true
              : false
          }
          helperText={
            touched?.invitationExpiryDays && errors?.invitationExpiryDays
              ? (errors?.invitationExpiryDays as string)
              : " "
          }
        />
      </FormControl>

      {/* <FormControl sx={{ ...InputWrapper, mt: 2 }}>
        <FormLabel sx={LabelStyle} htmlFor="survey-invitation">
          Send survey invitation on creation of a participant
        </FormLabel>
        <Select
          value={values.surveyInvitation}
          onChange={(e) => {
            setFieldValue("surveyInvitation", e.target.value);
            if (e.target.value === "immediate") {
              setFieldValue("offset", 0);
              setFieldValue("sendOnParticipantCreation", true);
            } else if (e.target.value === "after_x_days") {
              setFieldValue("offset", 1);
              setFieldValue("sendOnParticipantCreation", true);
            } else {
              setFieldValue("offset", 1);
              setFieldValue("sendOnParticipantCreation", false);
            }
          }}
          fullWidth
          id="survey-invitation"
        >
          {invitationOptions.map((option: any) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {values.surveyInvitation === "after_x_days" && (
        <FormControl sx={{ ...InputWrapper, mt: 2 }}>
          <FormLabel sx={LabelStyle} htmlFor="offset">
            Auto Send Offset <span style={{ color: "red" }}>*</span>
          </FormLabel>
          <TextField
            type="number"
            placeholder="Auto Send Offset"
            id="offset"
            {...getFieldProps("offset")}
            error={touched?.offset && errors?.offset ? true : false}
            helperText={
              touched?.offset && errors?.offset ? errors?.offset : " "
            }
          />
        </FormControl>
      )} */}
    </>
  );
};

export default Invitation;
